import TargetList from './TargetList';
export default TargetList;
//# sourceMappingURL=index.js.map
